<template>
    <div :class="[{'Tab--active': active}, 'Tab']">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'tab',

  data: function () {
    return {
      active: false
    }
  },
  props: {
    'title': {
      required: true,
      type: String
    },
    'isActive': {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    removeTab: function () {
      this.$destroy()
    }
  },
  created: function () {
    this.active = this.isActive
  },
  mounted: function () {
    this.$parent.addTab(this)
  }
}
</script>

<style lang="scss">
    @import "../../scss/_variables";

    .Tab {
        display: none;
        border: 1px solid #FFF;
        border-top: 0;
        padding: 15px;
        padding-bottom: 0;
        background-color: #FFF;
        margin-bottom: 15px;
        &--active {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Tabs/tab.vue